import React from 'react';
import { DATA_LAYERS } from '../../../lib/dataLayers';
import { LayerHeader } from './LayerHeader';
import { RESILIENCE_PRIORITY_PALETTE } from '../../../lib/resiliencePriorityColors';

/**
 * Left-panel content for the Resilience Priority spectrum layer. Restates
 * the matrix-based tier assignment for free-exploration users (in scenario
 * mode the panel shows the matrix insight card instead).
 */
export const ResiliencePriorityContent: React.FC = () => {
  const layer = DATA_LAYERS.resilience_priority;

  return (
    <div className="space-y-6">
      <LayerHeader layer={layer} />
      <div className="bg-figma-card rounded-figma-panel p-4 border border-figma-lime/30 shadow-figma-card">
        <p className="text-xs font-roboto-mono text-neutral-500 uppercase tracking-wider mb-2">
          Priority tier
        </p>
        <p className="text-body-sm font-roboto text-neutral-300 leading-relaxed">
          Each pixel's priority is assigned by a documented{' '}
          <span className="font-roboto-mono text-figma-lime">WHP × RD decision matrix</span>
          {' '}on private timberland (family + corporate ownership). Top-tier
          pixels are stands where high or very-high wildfire-hazard intersects
          dense or overstocked structure — the intersection where fuels-reduction
          thinning is most defensible.
        </p>
        <ul className="mt-3 space-y-1.5">
          {RESILIENCE_PRIORITY_PALETTE.order.map((tier) => (
            <li
              key={tier}
              className="flex items-center gap-2 text-body-sm font-roboto text-neutral-300"
            >
              <span
                className="inline-block w-3 h-3 rounded-sm flex-shrink-0"
                style={{ backgroundColor: RESILIENCE_PRIORITY_PALETTE.colors[tier] }}
                aria-hidden="true"
              />
              <span>{RESILIENCE_PRIORITY_PALETTE.labels[tier]}</span>
            </li>
          ))}
        </ul>
        <p className="mt-3 text-[11px] font-roboto text-neutral-400 italic leading-relaxed">
          The Carbon Defense scenario's matrix card breaks this down by
          WHP × RD cell, so a presenter can point at the red zones on the
          map and explain which combinations carry the weight.
        </p>
      </div>
    </div>
  );
};
